import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 24,
    height: 24,
  },
  path: {
    fill: '#690095',
  },
});

const CatalogIcon = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path className={classes.path} d="M16.25 1.25H5C4.66848 1.25 4.35054 1.3817 4.11612 1.61612C3.8817 1.85054 3.75 2.16848 3.75 2.5V5H2.5V6.25H3.75V9.375H2.5V10.625H3.75V13.75H2.5V15H3.75V17.5C3.75 17.8315 3.8817 18.1495 4.11612 18.3839C4.35054 18.6183 4.66848 18.75 5 18.75H16.25C16.5815 18.75 16.8995 18.6183 17.1339 18.3839C17.3683 18.1495 17.5 17.8315 17.5 17.5V2.5C17.5 2.16848 17.3683 1.85054 17.1339 1.61612C16.8995 1.3817 16.5815 1.25 16.25 1.25ZM16.25 17.5H5V15H6.25V13.75H5V10.625H6.25V9.375H5V6.25H6.25V5H5V2.5H16.25V17.5Z" fill="#1D2125"/>
      <path className={classes.path} d="M8.75 5H13.75V6.25H8.75V5ZM8.75 9.375H13.75V10.625H8.75V9.375ZM8.75 13.75H13.75V15H8.75V13.75Z" fill="#1D2125"/>
    </svg>
  );
};

export default CatalogIcon;
